import type { ICajaResume } from '@/interfaces/ICajaResume';

type ICajaResumeCanceledItemsView = Pick<
  ICajaResume,
  'ordersTotals' | 'canceledItemsDetails'
>;

/**
 * Units behind ordersTotals.canceledItems that the stored (producer-capped)
 * list does not cover. 0 when the resume or the list is absent or empty.
 */
export function getCanceledItemsOmittedUnits(
  resume: ICajaResumeCanceledItemsView | null | undefined
): number {
  const lines = resume?.canceledItemsDetails;
  // Frozen JSON is checked for shape: a malformed snapshot must not throw.
  if (!Array.isArray(lines) || !lines.length) return 0;

  const listed = lines.reduce((acc, line) => acc + line.quantity, 0);
  return Math.max(0, (resume.ordersTotals?.canceledItems ?? 0) - listed);
}
